<template>
  <div id="app">
    <div class="pika" @click="goHome">
      <img alt="pika" src="@/assets/pika.gif" />
    </div>
    <router-view />
  </div>
</template>

<script>
import firebase from "@/javascript/firebase";

export default {
  name: "app",
  components: {},
  data() {
    return {
      user: null
    };
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    }
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      this.user = user;
    });
  }
};
</script>

<style>
@import "../node_modules/@fortawesome/fontawesome-free/css/all.css";

body {
  margin: 0;
  height: 100vh;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  background-image: url("./assets/pikachubg.gif");
  background-size: cover;
  background-position-y: bottom;
  position: relative;
  background-color: black;
  background-repeat: no-repeat;
}

.pika {
  margin-top: 60px;
  display: inline-block;
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
  border: 7px solid #f62d14;
  animation: flash 1s infinite;
  position: absolute;
  right: 100px;
}

@keyframes flash {
  0% {
    border-color: #f62d14;
  }
  25% {
    border-color: #3b4cca;
  }
  50% {
    border-color: #fad61d;
  }
  75% {
    border-color: #419eae;
  }
  100% {
    border-color: #f62d14;
  }
}

.pika img {
  width: auto;
  height: 100%;
  position: absolute;
  right: -80px;
}

.pika:hover {
  cursor: pointer;
}
</style>
